import { graphql } from '~/graphql/generated/gql';

export const userCoinsTransactionsFragment = graphql(`
  fragment UserCoinsTransactionsFields on UserCoinsTransaction {
    id
    coins
    balanceBefore
    balanceAfter
    type
    referenceType
    referenceId
  }
`);

export const userProgressFragment = graphql(`
  fragment UserProgressFields on UserProgress {
    id
    completableId
    completableType
    startAt
    completedAt
    awardedCoins
    userCoinsTransaction {
      ...UserCoinsTransactionsFields
    }
    earnedAwards {
     ...EarnedAwardFields
    }
    completable {
      ... on LearningAssetCollection {
        id
        learningAssets {
          id
          currentUserProgress {
            id
            completedAt
            awardedCoins
          }
        }
        activeCampaign {
          ...LearningCampaignCollectionOverviewFields
        }
        # Resolved server-side after the completion is written, so this is the only reading of
        # the questionnaire taken at the moment the student actually finished — the page's copy
        # can be an hour old and predate the teacher switching feedback on or off. Being
        # post-write, it also already accounts for this student's own answer.
        feedbackSurvey {
          ...FeedbackSurveyDefinitionFields
        }
      }
    }
  }
`);
export const startUserProgress = graphql(`
  mutation startUserProgress($input: UserProgressInput!) {
    startUserProgress(input: $input) {
      userProgress {
        ...UserProgressFields
      }
    }
  }
`);

export const completeUserProgress = graphql(`
  mutation completeUserProgress($input: CompleteUserProgressInput!) {
    completeUserProgress(input: $input) {
      userProgress {
        ...UserProgressFields
      }
      earnedCoinTransaction {
        ...UserCoinsTransactionsFields
      }
      query {
        core {
          user {
            self {
              id
              latestCoinBalance
              latestRedemption {
                id
                createdAt
              }
              earnedBadgesCount
              considerationScore {
                percentage
                scoreRisk
              }
            }
          }
        }
      }
    }
  }
`);

export const learningFaqFragment = graphql(`
  fragment LearningFaqsField on LearningFaq {
    id
    question
    answer
    slug
    order
    section
    learningCampaignId
  }
`);

export const fetchLearnLearningAssetCollectionDetail = graphql(`
  query fetchLearnLearningAssetCollectionDetail($filters: LearningAssetCollectionFilters) {
    learningAssetCollections(first: 1, filters: $filters) {
      data {
        ...LearningAssetCollectionExploreFields
        description
        backgroundImageKey
        meta {
          title
          description
        }
      }
    }
  }
`);

export const fetchCollectionsByCategory = graphql(`
  query fetchCollectionsByCategory($category: CollectionCategory!) {
    collectionsInCategory(category: $category) {
      ...LearningAssetCollectionChildFields
    }
  }
`);

export const fetchSelfDiscoveryLearningAssets = graphql(`
  query fetchSelfDiscoveryLearningAssets($considerationAreaSlug: String!, $types: [LearningAssetType!]!, $first: Int!) {
    learningAssets(
      filters: { considerationAreaSlug: $considerationAreaSlug, types: $types, publishedOnly: true }
      first: $first
    ) {
      data {
        id
        name
        subtitle
        slug
        duration
        coverImage {
          publicUrl
        }
      }
    }
  }
`);

export const learningAssetCollectionChildFieldsFragment = graphql(`
  fragment LearningAssetCollectionChildFields on LearningAssetCollection {
    id
    name
    collectionType
    coverImage {
      ...PublicFileFields
    }
    partners {
      id
      name
      iconFile {
        ...PublicFileFields
      }
    }
    order
    slug
    meta {
      title
      description
    }
    publishedAt
    description
    backgroundImageKey
    learningAssets {
      id
      name
      slug
      duration
      publishedAt
      coinValue {
        ...CoinValueFields
      }
      coverImage {
        ...PublicFileFields
      }
      currentUserProgress {
        id
        startAt
        completedAt
        awardedCoins
      }
    }
    categories {
      category
      order
    }
  }
`);
